import React from 'react';
import withIcon from '../utilities/withIcon';

const IconGlobe = () => {
  return (
    <g>
      <path d="m8 .1626a7.8374 7.8374 0 1 0 7.8374 7.8374 7.847 7.847 0 0 0 -7.8374-7.8374zm5.7029 4.8638h-2.7229a10.76 10.76 0 0 0 -1.465-3.2764 6.4548 6.4548 0 0 1 4.1884 3.2764zm.7341 2.9736a6.4073 6.4073 0 0 1 -.247 1.7466h-3.1179a10.8857 10.8857 0 0 0 .1641-3.32h2.9984a6.4075 6.4075 0 0 1 .2024 1.5734zm-8.367 1.7466a9.2635 9.2635 0 0 1 .03-3.32h3.7392a9.46 9.46 0 0 1 -.1564 3.32zm3.2011 1.4a12.8 12.8 0 0 1 -1.3688 2.6967 10.0518 10.0518 0 0 1 -1.46-2.6967zm-7.7081-3.1466a6.407 6.407 0 0 1 .2026-1.5732h2.95a10.7047 10.7047 0 0 0 -.0457 3.32h-2.8599a6.407 6.407 0 0 1 -.247-1.7468zm4.8963-2.9736a12.7285 12.7285 0 0 1 1.4935-3.06 9.907 9.907 0 0 1 1.58 3.06zm-.0082-3.267a14.544 14.544 0 0 0 -1.4149 3.267h-2.74a6.455 6.455 0 0 1 4.1549-3.267zm-4.0606 9.3876h2.5867a10.9571 10.9571 0 0 0 1.4957 3.0992 6.4546 6.4546 0 0 1 -4.0824-3.0992zm6.8552 3.1667a14.6892 14.6892 0 0 0 1.4648-3.1667h2.8995a6.4525 6.4525 0 0 1 -4.3643 3.1667z" />
    </g>
  );
};

export default withIcon(IconGlobe);
